import { signInWithEmailAndPassword } from "firebase/auth";
import FirebaseConfiguration from "./config/firebase";

export default async function ({
  email,
  password,
}: {
  email: string;
  password: string;
}) {
  return await signInWithEmailAndPassword(
    FirebaseConfiguration.auth,
    email,
    password
  );
}
